import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useEffect } from "react";

import SongsAddPlaylist from "@/features/songs/playlist/SongsAddPlaylist";
import SideNavLayout from "@/layouts/SideNavLayout";
import { SongsMenu } from "@/layouts/SubSideNavMenus";

function CreatePlaylistPage() {
  const flags = useFlags();
  const navigate = useNavigate();
  const enabled = flags["pd-add-playlist-feature"] === true;

  useEffect(() => {
    if (!enabled)
      void navigate({ to: "/songs", replace: true });
  }, [enabled, navigate]);

  if (!enabled)
    return null;

  return (
    <SideNavLayout menu={<SongsMenu />}>
      <SongsAddPlaylist key="create-playlist" />
    </SideNavLayout>
  );
}

export const Route = createFileRoute("/_auth/songs/create-playlist")({ component: CreatePlaylistPage });
